import { render } from "./document-block-menu.vue?vue&type=template&id=2c6efe82&scoped=true&ts=true&lang=pug"
import script from "./document-block-menu.vue?vue&type=script&lang=ts"
export * from "./document-block-menu.vue?vue&type=script&lang=ts"

import "./document-block-menu.vue?vue&type=style&index=0&id=2c6efe82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6efe82"]])

export default __exports__